import { REACT_APP_PUBLIC_URL } from 'env'
export interface Brand {
  name: string
  shortDescription: string
  longDescription: string
  favicon: string
  defaultFoldersLocation: string
}

const blazeNewDesignSystem: Brand = {
  name: 'Blaze',
  shortDescription: 'AI that does marketing for you',
  longDescription:
    'Blaze is the first agentic AI marketer that creates your strategy, auto-posts content, and learns from every post so your marketing drives more growth every week.',
  favicon: `${REACT_APP_PUBLIC_URL}/blazeFavicon.ico`,
  defaultFoldersLocation: 'All Files',
}

export const useBrand = () => {
  return blazeNewDesignSystem
}
